<template>
  <div>
    <!-- Mobile Navigation -->
    <v-navigation-drawer class="navigation__drawer" v-if="sidebar" v-model="sidebar" width="100vw" height="max-content"
      app>
      <v-list class="navigation__list-mobile">
        <v-list-item class="navigation__list-mobile-item" v-if="!loggedIn">
          <v-list-item-content>
            <a :href="'/'">Free list</a>
          </v-list-item-content>
        </v-list-item>
        <v-list-item class="navigation__list-mobile-item" v-else>
          <v-list-item-content>
            <a :href="'/'">Database</a>
          </v-list-item-content>
        </v-list-item>
        <v-list-item class="navigation__list-mobile-item" v-if="!loggedIn">
          <v-list-item-content>
            <a :href="'https://about.saaspricingpages.com/'">Search over 1000+ SaaS companies</a>
          </v-list-item-content>
        </v-list-item>
        <v-list-item class="navigation__list-mobile-item" v-else>
          <v-list-item-content>
            <a :href="'https://about.saaspricingpages.com/'">About</a>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <!-- Desktop Navigation -->
    <v-app-bar app height="70" class="navigation-bar">
      <span class="hidden-sm-and-up">
        <v-app-bar-nav-icon class="hello" v-show="showNavIcon" @click="iconNavClick">
        </v-app-bar-nav-icon>
        <v-icon v-show="sidebar || isMobileFilter" @click="iconCloseClick" size="18" color="white">
          mdi-close
        </v-icon>
      </span>
      <v-toolbar-title>
        <router-link v-if="!isMobileFilter" class="navigation__logo text-body-1" to="/" tag="span"
          style="cursor: pointer">
          {{ appTitle }}
        </router-link>
        <span v-if="isMobileFilter" class="navigation__logo text-body-1">Filter</span>
      </v-toolbar-title>
      <!-- <v-spacer></v-spacer> -->
      <v-toolbar-items class="navigation__list-desktop ms-auto">
        <v-btn text v-if="!loggedIn" :href="'/'" 
          class="navigation__list-desktop-item hidden-xs-only">
          <span class="active-underline">Free list</span>
        </v-btn>
        <v-btn text v-else :href="'/'" 
          class="navigation__list-desktop-item hidden-xs-only">
          <span class="active-underline">Database</span>
        </v-btn>
        <v-btn text v-if="!loggedIn" :href="'https://about.saaspricingpages.com/'"
          class="navigation__list-desktop-item hidden-xs-only">
          Search over 1000+ SaaS companies
        </v-btn>
        <v-btn text v-else :href="'https://about.saaspricingpages.com/'"
          class="navigation__list-desktop-item hidden-xs-only">
          About
        </v-btn>
        <v-btn v-if="!loggedIn" text class="navigation__list-desktop--upgrade-button" :href="'https://about.saaspricingpages.com/'">
          Download full list
        </v-btn>
        <v-btn v-else icon class="navigation__list-desktop-item navigation__list-desktop-item-user hidden-xs-only" @click.stop="userDrawer = !userDrawer">
          <v-icon>mdi-account-outline</v-icon>
        </v-btn>
        <icon-filter @click.native="iconFilterClick" v-if="loggedIn && showFilterIcon" class="hidden-sm-and-up" />
      </v-toolbar-items>
    </v-app-bar>
    <v-navigation-drawer right absolute v-model="userDrawer" width="400">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            Your information
          </v-list-item-title>
          <v-list-item-subtitle class="pt-3">
            {{ user.email }}
          </v-list-item-subtitle>
          <v-list-item-subtitle class="pt-3">
            {{ user.hash }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-navigation-drawer>
  </div>
</template>

<script>
import IconFilter from "./icons/IconFilter.vue";
export default {
  components: { IconFilter },
  name: "Navigation",
  props: {
    isMobileFilter: {
      default: false
    },
    loggedIn: {
      default: false
    }
  },
  data() {
    return {
      user: {},
      userDrawer: false,
      appTitle: "saas pricing pages",
      sidebar: false,
      // loggedIn: false,
      showFilterIcon: true,
      showNavIcon: true
    };
  },
  created() {
    this.$store.dispatch("retrieveUserDetails").then(() => {
      this.user = this.$store.getters.user;
    });
  },
  methods: {
    iconFilterClick() {
      this.showFilterIcon = false;
      this.showNavIcon = false;
      this.$emit("icon-filter-clicked");
    },
    iconCloseClick() {
      this.sidebar = false;
      this.showFilterIcon = true;
      this.showNavIcon = true;
      this.$emit("icon-close-clicked");
    },
    iconNavClick() {
      this.sidebar = true;
      this.showNavIcon = false;
    }
  }
};
</script>

<style>
.user-menu {
  /* position: relative; */
  top: 70px !important;
}

.navigation-bar.theme--light.v-app-bar.v-toolbar.v-sheet {
  background-color: #030134;
  color: #ffffff;
  box-shadow: none;
  z-index: 9;
}

.navigation-bar .v-toolbar__content {
  padding: 4px 24px !important;
}

.navigation-bar .v-app-bar__nav-icon.theme--light.v-btn.v-btn--icon {
  color: #ffffff;
}

.navigation-bar .v-btn--icon.v-size--default .v-icon {
  padding-top: 2px;
  width: 24px;
  margin-right: 12px;
  margin-top: 3px;
}

.navigation-bar .theme--light.v-btn--active:before {
  opacity: 0;
}

.navigation-bar .mdi-close {
  margin-right: 12px;
  margin-top: 3px;
}

.navigation__logo {
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 800;
  letter-spacing: -.6px;
}

.navigation__list-desktop {
  align-items: center;
}

.navigation__list-desktop .theme--light.v-btn {
  color: #ffffff;
  text-transform: none;
}

.navigation__list-desktop {
  font-weight: bold;
}

.navigation__list-desktop .navigation__list-desktop-item {
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.navigation__list-desktop .navigation__list-desktop-item:not(:last-child) {
  /* margin-right: 32px; */
  /* margin-right: 0px !important; */
}

.navigation__list-desktop .navigation__list-desktop-item-user {
  /* margin-right: 32px; */
  padding-bottom: 8px;
}

.navigation__list-desktop .navigation__list-desktop-item:nth-child(2) {
  position: relative;
  margin-right: 12px !important;
}

.navigation__list-desktop .navigation__list-desktop-item.v-btn--active .v-btn__content::after,
.navigation__list-mobile-item .router-link-exact-active::after {
  content: "";
  background-color: #f6c1c0;
  padding: 0px 16px;
  width: 100%;
  height: 2px;
  position: absolute;
  left: 0px;
  top: 20px;
}

.active-underline {
  border-bottom: 1px solid #f8d153;
}

.navigation__list-desktop .navigation__list-desktop--upgrade-button {
  background-color: #f8d153;
  font-weight: 700;
  color: #030134 !important;
  border-radius: 12px;
  padding: 8px 18px !important;
  height: max-content !important;
}

.navigation__list-desktop .navigation__list-desktop--upgrade-button .v-btn__content {
  line-height: 25px;
  letter-spacing: normal;
}

/* Mobile View Navigation Drawer */
.navigation__drawer {
  top: 70px !important;
  background-color: #030134 !important;
}

.navigation__drawer .navigation__list-mobile-item:not(:last-child) {
  margin-bottom: 38px;
}

.navigation__drawer .navigation__list-mobile-item:last-child {
  margin-bottom: 26px;
}

.navigation__drawer .v-list-item__content a {
  position: relative;
  color: #ffffff;
  text-decoration: none;
  flex: unset;
}

/* Responsive Media Queries */

@media (max-width: 599px) {
  .navigation__logo {
    font-size: 16px;
  }

  .navigation__list-desktop .navigation__list-desktop-item:last-child {
    padding: 5.5px 13px;
  }

  .navigation-bar .v-toolbar__content {
    padding: 4px 14px !important;
  }

  .v-list .navigation__list-mobile {
    position: relative;
  }

  .v-list.navigation__list-mobile::before {
    content: "";
    background-color: #2f2f40;
    width: 92%;
    height: 1px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 0px;
  }
}

@media (min-width: 599px) and (max-width: 690px) {
  .navigation__logo {
    font-size: 18px;
  }
}
</style>
